import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SocialMediaCreateService } from '../../services';

export const fetchSocialMediaCreate = createAsyncThunk(
    'socialMediaCreate/fetchSocialMediaCreate',
    async ({ file, title, slug }) => {
        const response = await SocialMediaCreateService(file, title, slug)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const socialMediaCreateSlice = createSlice({
    name: 'socialMediaCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaCreateSlice.reducer;
